<template>
  <div id="deliveryArea">

    <div class="deliveryArea-header">
      <img src="../../../assets/icon/close2.png" class="deliveryArea-header-close" @click="close"/>
      <!--<router-link to="/register" slot="right">-->
        <!--<span class="loginEntrance-header-register">注册</span>-->
      <!--</router-link>-->
      <div class="deliveryArea-header-title">查看配送区域</div>
      <div></div>

    </div>
    <hr style="" class="deliveryArea-hr"/>


    <div class="deliveryArea-search">
      <div class="deliveryArea-search-textfield">
        <img src="../../../assets/icon/search.jpg" id="deliveryArea-search-img"/>
        <input type="text"
               style="color:#191919"
               v-model="addr"
               placeholder="请输入地址查看是否在配送范围内"
               @focus="lableOnFocus"
               @blur="lableOnBlur"
               class="deliveryArea-search-lable"/>

      </div>
    </div>
    <div class="deliveryArea-content">
      <baidu-map class="map-container"
                 ak="kG0GHj7Kn2EzPRsRhog4BvWW5zoEskNl"
                 :center="center"
                 @ready="handler"
                 :zoom="zoom"
                 :min-zoom="10"
                 :max-zoom="13"
                 :inertial-dragging="true"
                 :scroll-wheel-zoom="true"
      >

        <bm-polygon :path="polygonPath"
                    stroke-color="#3d2d23"
                    :stroke-opacity="0.5"
                    fillColor="#3d2d23"
                    :stroke-weight="1"
                    :fill-opacity="0.2"
                    v-for="(polygonPath,index) in polygonPaths" :key="index"
        ></bm-polygon>
        <bm-marker :position="currentCenter" animation="BMAP_ANIMATION_BOUNCE" v-if="currentCenter !== undefined"></bm-marker>
        <bm-local-search :keyword="addr"
                         :auto-viewport="false"
                         :panel="false"
                         :selectFirstResult="false"
                          @markersset="markerssetEvent"
        @searchcomplete="searchcomplete"></bm-local-search>

      </baidu-map>

    </div>

    <div class="deliveryArea-content deliveryArea-content-locationView" v-show="showSearchView === true" @click="hideEvent">
      <div class="deliveryArea-content-resultView">
        <div v-for="address in results" class="deliveryArea-content-addr" @click="selectedAddr(address)">

          <div style="margin-left: 20px;margin-right: 20px; " class="deliveryArea-content-lable">{{address.title}} - {{address.address}}</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  //  import { MessageBox } from 'mint-ui'

  import mapHelper from '../../../js/mapHelper'
  import api from '../../../api/common/api.common'
  import config from '../../../config'// 配置
  import {BaiduMap} from 'vue-baidu-map'
  import {BmPolygon} from 'vue-baidu-map'
  import {BmMarker} from 'vue-baidu-map'
  import {BmLocalSearch} from 'vue-baidu-map'
  //
  export default {
    name: 'deliveryArea',
    components: {
      BaiduMap,
      BmPolygon,
      BmMarker,
      BmLocalSearch
    },
    data () {
      return {
        oldMarker: undefined,
        map: undefined,
        addr: '',
        showSearchView: false,
        currentCity: {},
        results: [],
        marker: undefined,
        center: {lng: 113.96055514892, lat: 22.544916221614},
//        polygonPath: [],
        polygonPaths: [],
        readyPolygonPath: [],
        markerPoint: undefined,
        currentCenter: undefined,
        zoom: '11'
      }
    },
    mounted () {
      this.init()

      var self = this
      api.getStationList({},function (respond) {
        var models = respond.body.data;
        console.log(models);
        var polygonPaths = []
        for (var x in models) {
          var coordVals = models[x]
          var polygonPath = []
          coordVals.forEach(function (val) {
            var newCoord = {}
            newCoord.lng = val.longitude
            newCoord.lat = val.latitude
            polygonPath.push(newCoord)
          })
          polygonPaths.push(polygonPath)
        }
        self.polygonPaths = polygonPaths
        console.log(polygonPath)
      })
    },
    watch: {
      addr ( newVal,oldVal ) {
        if (newVal.length > 0) {
          this.zoom = 13
        } else {
          this.zoom = 11
          this.center = this.currentCenter

          var self = this
          this.results&&this.results.forEach(function (res) {
            self.map.removeOverlay(res.marker)
          })
        }

      }
    },
    destroyed () {
    },
    computed: {
    },
    methods: {
      searchcomplete (result) {

        var self = this
        if (result !== undefined && this.addr === result['keyword']) {
          this.results = result.vr
        } else if (result !== undefined && this.addr.length === 0) {
          this.results = []
          result.vr&&result.vr.forEach(function (res) {
            setTimeout(function () {
              self.map.removeOverlay(res.marker)
            },500)

          })
        }

      },
      markerssetEvent (pois) {
      },
      lableOnBlur () {
//        this.showSearchView = false
        var self = this
        setTimeout(function () {
          self.showSearchView = false
        },200)
      },
      selectedAddr (add) {
        var self = this
        if (this.oldMarker !== undefined) {
          this.map.removeOverlay(this.oldMarker)
        }
        this.center = add.point

        this.results.forEach(function (res) {
          self.map.removeOverlay(res.marker)
        })
        self.map.addOverlay(add.marker)
        self.oldMarker = add.marker
      },
      hideEvent () {
        this.showSearchView = false
      },
      lableOnFocus () {
        this.showSearchView = true
      },
      close () {
        this.$router.go(-1)
      },
      init(){

        var self = this

        mapHelper.getLoaclLocation(function (respond) {

          self.center.lng = respond.longitude
          self.center.lat = respond.latitude

          var point = {}
          point.lng = respond.longitude
          point.lat = respond.latitude
          self.currentCenter = point
          self.currentCity = respond

        })

      },
      getPolygonArr (coords) {
        var coordsArr = [];
        coords.forEach( function(c) {
          coordsArr.push(new BMap.Point(c.longitude, c.latitude));
        });
        return coordsArr;
      },
      handler ({BMap, map}) {
        this.map = map;
      }
    }
  }
</script>



<style lang="scss">
  @import '../../../assets/css/mixin';
  #deliveryArea {
    position: fixed;
    top: 0;
    left:0;
    right:0;
    bottom: 0;
  }

  .deliveryArea-header {
    position: fixed;
    height: pxToRem(100px);

    top: 0px;
    left: pxToRem(30px);
    right: pxToRem(30px);

    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .deliveryArea-header-close {
    width: pxToRem(20px);
  }

  .deliveryArea-header-title {
    font-size: pxToRem(24px);
    color: #191919;
  }

  .deliveryArea-search {
    position: fixed;
    height: pxToRem(134px);
    left:0;
    right:0;
    top:pxToRem(100px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .deliveryArea-content {
    position: absolute;
    top: pxToRem(234px);
    left:0;
    right:0;
    bottom:0px;
  }
  .deliveryArea-content-locationView {
    z-index: 666;
    background-color: transparent;
  }

  .map-container {
    position: absolute;
    top: 0;
    left:0;
    right:0;
    bottom:0;
    /*z-index: 100;*/
    /*margin-top: pxToRem(234px);*/
    height: 100%;
    /*height: pxToRem(970px);*/
    /*width: 300px;*/
    /*background-color: #26a2ff;*/
  }

  .deliveryArea-hr {
    position: absolute;
    top: pxToRem(100px);
    left:0;
    right:0;
    height: 1px;
    background-color: #d8d8d8;
  }

  .deliveryArea-search-textfield {

    height: pxToRem(66px);
    width: 86.666666666%;
    border: solid 1px rgba(102,102,102,0.5);
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  #deliveryArea-search-img {
    width: pxToRem(35px);
    margin-left: pxToRem(20px);
  }
  .deliveryArea-search-lable {
    color: #9b9b9b;
    margin-left: pxToRem(20px);
  }
  .deliveryArea-search-lable {
    width: 70%;
  }

  .deliveryArea-content-resultView {
    background-color: transparent;
    margin-top: pxToRem(10px);
    margin-left: pxToRem(50px);
    margin-right: pxToRem(50px);
    height: pxToRem(600px);

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: scroll;
    flex-direction: column;
  }
  .deliveryArea-content-addr {
    color: #191919;
    font-size: pxToRem(24px);
    margin-bottom: pxToRem(10px);
    background-color: white;
    width: 100%;
  }
  .deliveryArea-content-lable {
    background-color: white;
    margin-top: pxToRem(20px);
    margin-bottom: pxToRem(20px);
  }
</style>


// WEBPACK FOOTER //
// deliveryArea.vue?25031251